import { useContext, useEffect, useRef } from 'react';
import { AccountContext } from '@/context/account.context';
import { LocationContext } from '@/context/location.context';

const useLocation = () => {
  const account = useContext(AccountContext);
  const locationContext = useContext(LocationContext);
  const initiated = useRef(false);

  // Wait for loading from localStorage to resolve before calling initLocation.
  // location and region start as undefined (loading) and settle to false or a real
  // value once the LocationProvider's storage effect fires. We only call initLocation
  // once — the ref prevents re-triggering on subsequent location updates.
  useEffect(() => {
    if (locationContext.location !== undefined && locationContext.region !== undefined && !initiated.current) {
      initiated.current = true;
      locationContext.initLocation({ skipStaleRefresh: account?.cachedUser?.is_professional });
    }
  }, [locationContext.location, locationContext.region]);

  return {
    locationContext
  };
};

export default useLocation;
